/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const DeviceMutationResponse = zod.object({
  success: zod.literal(true),
});

export type DeviceMutationResponse = zod.input<typeof DeviceMutationResponse>;
export type DeviceMutationResponseOutput = zod.output<typeof DeviceMutationResponse>;
